// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JP0_0","label":"styles_label__3_KGR"};